import { ace_index } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function find({ url: { service: baseURL }, token }: IAPI) {
  return async function find(
    query: ace_index.FindInput
  ): Promise<ace_index.FindResult> {
    const url = new URL(`/ace-index/find`, baseURL);
    try {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(query),
      });
      if (!response.ok) {
        if (response.status === 504) {
          throw new TypeError('Query timed out');
        }
        throw new Error('Network response was not ok');
      }
      return response.json();
    } catch (e) {
      throw new Error(
        e instanceof Error
          ? `Failed to search: ${e.message}`
          : 'Failed to search'
      );
    }
  };
}
